import { Box } from "@chakra-ui/react";
import PageLayout from "../../components/page-layout";
import CoachPricingManagementPage from "../coach-pricing-management/components/CoachPricingManagementPage";
import CourtPricingManagementList from "../court-pricing-management/components/CourtPricingManagementList";
import GameCapacityManagementPage from "../game-capacity-management/GameCapacityManagementPage";
import GameDurationManagementPage from "../game-duration-management/GameDurationManagementPage";
import GuidedTour from "../walkthrough/components/GuidedTour";
import { PRICING_TOUR_ID, pricingTourSteps } from "../walkthrough/tours/pricing-tour";
import BookingPaymentDeadlineCard from "./components/BookingPaymentDeadlineCard";
import CguPolicyCard from "./components/CguPolicyCard";
import DefaultMembershipTypeCard from "./components/DefaultMembershipTypeCard";
import DiscountPolicyCard from "./components/DiscountPolicyCard";
import RefundDeadlinePolicyCard from "./components/RefundDeadlinePolicyCard";

export default function PricingManagementPage() {
    return (
        <PageLayout>
            <GuidedTour tourId={PRICING_TOUR_ID} steps={pricingTourSteps()} />
            <Box data-tour="court-pricing"><CourtPricingManagementList /></Box>
            <Box data-tour="coach-pricing"><CoachPricingManagementPage /></Box>
            <Box data-tour="game-duration"><GameDurationManagementPage /></Box>
            <GameCapacityManagementPage />
            <Box data-tour="refund-policy"><RefundDeadlinePolicyCard /></Box>
            <BookingPaymentDeadlineCard />
            <Box data-tour="discount-policy"><DiscountPolicyCard /></Box>
            <DefaultMembershipTypeCard />
            <Box data-tour="cgu-policy"><CguPolicyCard /></Box>
        </PageLayout>
    );
}
